/**
 * Texts for Library page
 */
export const libraryPageText = {
    title: 'CamAPS Liberty - CamAPS FX',
    titleMeta: 'CamAPS Liberty - CamAPS FX',
    descriptionMeta: 'Adgang til ressourcer og støttemateriale til CamAPS FX og CamAPS Liberty®.',
    keywords: 'camaps bibliotek, camaps fx, camaps liberty, støtteressourcer, diabeteshåndtering',
    localeMeta: 'da_dk',

    bannerTitle: 'Støtte ud over tallene',
    bannerSubtitle: 'med CamAPS Liberty<sup>®</sup>',
    bannerDescription: 'Når aktiveret, behøver brugere ikke at tælle kulhydrater og afgive en for-måltids insulinbolus.',
    bannerCompatibility: 'Kompatibel med Android og iOS',
    
    announcementText: 'Kommer snart til myLoop AID-brugere*',
    announcementDisclaimer: '* Afventer lokale markedsgodkendelser og tilgængelighed',

    introTitle: 'Den første fuldt lukkede loop-funktion. Når du har brug for den.',
    introDescription: 'Når den er aktiveret, behøver brugere ikke at tælle kulhydrater og give en for-måltid insulinbolus.',
    introSubtext: 'Tilgængelig på Android- og Apple-operativsystemer',

    howItWorksTitle: 'Hvordan virker det?',
    howItWorksDescription: 'Drevet af en mere proaktiv version af CamAPS-algoritmen. CamAPS Liberty forudser og reagerer på glukoseændringer, mens etablerede sikkerhedsgrænser opretholdes.',
    
    step1Title: 'TRIN 1',
    step1Description: 'Gå fra din startskærm til indstillingerne.',
    step2Title: 'TRIN 2',
    step2Description: 'Rul ned til bunden og tryk på kontakten for at aktivere.',
    step3Title: 'TRIN 3',
    step3Description: 'Ved første brug skal du se vores forklarende video om CamAPS Liberty.',
    step4Title: 'TRIN 4',
    step4Description: 'Bekræft, at du ikke er under 13 år eller gravid.',
    step5Title: 'TRIN 5',
    step5Description: 'Tryk på kontakten igen for at aktivere.',
    step6Title: 'TRIN 6',
    step6Description: "Alt er klar. CamAPS Liberty-fanen vises på din startskærm<sup>†</sup>.",
    step6Footnote: "<sup>†</sup> Virker kun, når \"Auto mode\" er tændt",

    eligibilityTitle: 'Hvem kan bruge CamAPS Liberty?',
    eligibilityCriterion1: 'Eksisterende brugere med type 1 diabetes',
    eligibilityCriterion2: '13 år og ældre',
    eligibilityCriterion3: 'Gravid',
    parentsCarersTitle: 'Hvad med forældre og omsorgspersoner?',
    parentsCarersBlockTitle: 'Funktionen "Blokér":',
    parentsCarersBlockDescription: 'For at forhindre utilsigtet brug',
    parentsCarersRemoteTitle: 'Fjernovervågning:',
    parentsCarersRemoteDescription: 'Companion, Glooko® og CamAPS 2-ugers PDF-rapporter',

    imageOverlayText: 'Designet til at fungere sammen med din nuværende diabeteshåndteringsplan; ikke for at erstatte den.',
    
    usingTitle: 'Bruge CamAPS Liberty',
    
    treatmentPlanText: 'CamAPS Liberty er udviklet til at fjerne behovet for rutinemæssige måltidsbolusser. Funktionen erstatter ikke de øvrige elementer i brugerens diabetesbehandlingsplan, herunder regelmæssig gennemgang med diabetesteamet.',
    
    usingLibertyTitle: 'Se og lær om CamAPS Liberty',
    usingLibertyDescription: 'Udforsk videoer for at lære mere om CamAPS Liberty og hvordan du kommer i gang.',
    // latestVideoLabel removed
    moreVideosLabel: 'Flere videoer',
    factsheetDownloadText: 'CamAPS Liberty-faktablad (pdf)',
    factsheetUrl: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/camaps_liberty_faqs_dk.pdf',
    usingLibertyFeaturedVideo: {
        youtubeUrl: 'https://youtu.be/px9QSOhy544',
        title: 'CamAPS Liberty: Kom godt i gang',
        description: 'Candice Ward forklarer, hvordan du konfigurerer og begynder at bruge CamAPS Liberty.',
        duration: '31:50',
        date: '15 Sep 2026',
    },
    usingLibertyMoreVideos: [
        {
            youtubeUrl: 'https://youtu.be/AVPeOgmRozk',
            title: 'Praktiske Tips: CamAPS Liberty',
            duration: '01:55',
        },
        {
            youtubeUrl: 'https://youtu.be/K7_j-Sk5Fas',
            title: 'Introduktion til CamAPS Liberty',
            duration: '14:42',
        },
        {
            youtubeUrl: 'https://youtu.be/0dp5A8z_SEk',
            title: 'Den fully closed-loop-følelse',
            duration: '04:22',
        },
        {
            youtubeUrl: 'https://youtu.be/Er-5xyuDC1Q',
            title: 'CamAPS Liberty-funktionen',
            duration: '03:26',
        }
    ],
    
    whatHappensNextTitle: 'Hvad sker der næste?',
    whatHappensNextText: 'Vi vil køre en pilot inden for et enkelt marked i de kommende måneder. Hold øje med flere detaljer.',
};

